// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"108":"eb0d903e0e0c1405","561":"79193835be16cd95"}[chunkId] + ".js";
};